import { Space } from "antd-mobile";
export default Space;
